<template>
    <section class="flex flex-wrap place-items-stretch gap-4 lg:grid-flow-col lg:gap-6">
        <div class="flex w-full flex-col items-stretch gap-4 lg:w-[calc(50%-12px)] lg:gap-6">
            <TextComponent v-if="textBlock" class="h-full" v-bind="textBlock" />
            <img
                :src="image?.url + '?width=660&format=webp'"
                :alt="image?.alt"
                class="h-full max-h-53.25 w-full rounded-lg object-cover lg:order-last lg:col-span-6 lg:row-start-2 lg:row-end-3 lg:max-h-51" />
        </div>
        <PricingBlock
            v-bind="pricingBlock?.pricingBlockModel"
            class="w-full lg:order-2 lg:w-[calc(50%-12px)]" />
    </section>
</template>
<script lang="ts" setup>
import type { GetStartedComponentModel } from '@su4r-frontend/api';

defineProps<GetStartedComponentModel>();
</script>
